export const generateThumbnail = (file: File, maxSize = 150): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const scale = maxSize / Math.max(img.width, img.height);
        canvas.width = img.width * scale;
        canvas.height = img.height * scale;

        const ctx = canvas.getContext("2d");
        if (!ctx) return reject("Failed to get canvas context");

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject("Failed to create thumbnail");
          },
          "image/jpeg",
          0.75
        );
      };
      img.onerror = reject;
      img.src = e.target?.result as string;
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const resizeImage = (file: File, maxSize = 1024): Promise<any> => {
  return new Promise((resolve) => {
    const img = new Image();
    const url = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const scale = Math.min(maxSize / img.width, maxSize / img.height);
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;

      const ctx = canvas.getContext("2d");
      ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);

      canvas.toBlob((blob) => {
        if (blob) {
          const resizedUrl = URL.createObjectURL(blob);
          const resizedFile = new File([blob], file.name, {
              type: "image/jpeg",
              lastModified: Date.now(),
            });
          resolve({resizedUrl, resizedFile});
        } else {
          resolve({url, file}); // fallback
        }
      }, "image/jpeg", 0.9);
    };

    img.src = url;
  });
};

export const addImageClass = (event: any): void => { 

  const imgElement = event.target as HTMLImageElement;
  const isPortrait = imgElement.naturalHeight > imgElement.naturalWidth;
  if (isPortrait) {
    imgElement.classList.add('imagePortrait');
    return;
  } else {
    if (imgElement.naturalHeight === imgElement.naturalWidth) {
      imgElement.classList.add('imageSquare');
      return; // No need to add landscape class if it's square
    } else {
        imgElement.classList.add('imageLandscape');
        return;
    }
  }

}




